import { useQuery } from '@tanstack/react-query';
import { Building, ChevronDown, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { factory } from '@/utils/queryFactory';
import { useDeveloperFilterStore } from '../Store/store';
import { findSelectedSource } from '../utils/utils';
import Content from './Content';

export const ALL_DEVELOPERS = 'Alla bostadsutvecklare';

const PopoverWrapper = () => {
  const { developerId, setDeveloperId } = useDeveloperFilterStore();

  const { data } = useQuery({
    ...factory.sources.all(),
    select: (sources) => ({
      ...sources,
      sources: [...sources].sort((a, b) => a.name.localeCompare(b.name, 'sv')),
    }),
  });

  const developerSources = data?.sources ?? [];

  const selectedSourceName = findSelectedSource(developerSources, developerId)?.name ?? ALL_DEVELOPERS;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          role='combobox'
          className='laptop:w-full w-60 justify-between'
        >
          <div className='flex min-w-0 items-center gap-1.5'>
            <Building
              size={18}
              strokeWidth={1.5}
              className='shrink-0'
            />
            <span
              className='min-w-0 truncate'
              title={selectedSourceName}
            >
              {selectedSourceName}
            </span>
          </div>
          <div className='flex shrink-0 items-center gap-1'>
            {selectedSourceName !== ALL_DEVELOPERS && (
              // biome-ignore lint/a11y/useSemanticElements: cannot nest a <button> inside the combobox trigger button; span with role=button + keyboard handler is the accessible compromise
              <span
                role='button'
                tabIndex={0}
                title='Rensa bostadsutvecklare'
                className='hover:bg-muted flex cursor-pointer items-center justify-center rounded-md p-1
                  focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2'
                onClick={(e) => {
                  e.stopPropagation();
                  setDeveloperId({ developerId: null });
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    setDeveloperId({ developerId: null });
                  }
                }}
              >
                <X className='h-4 w-4' />
              </span>
            )}
            <ChevronDown className='h-4 w-4 opacity-50' />
          </div>
        </Button>
      </PopoverTrigger>

      <PopoverContent
        align='start'
        className='p-0'
      >
        <Content developerSources={developerSources} />
      </PopoverContent>
    </Popover>
  );
};

export default PopoverWrapper;
